import { AccordionDesignTokens } from '@primeuix/themes/types/accordion';

import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const accordionOverride: AccordionDesignTokens = {
  root: {
    transitionDuration: '0.5s',
  },
  panel: {
    borderWidth: getRem(0),
  },
  header: {
    background: 'transparent',
    activeBackground: 'transparent',
    hoverBackground: 'transparent',
    activeHoverBackground: 'transparent',
    fontWeight: getFontWeight('semibold'),
    hoverColor: getColor('SeaBlue'),
    color: getColor('SeaBlue'),
    activeColor: getColor('SeaBlue'),
    activeHoverColor: getColor('SeaBlue'),
    padding: `${getRem(10)} ${getRem(0)} ${getRem(12)} ${getRem(0)}`,
    toggleIcon: {
      color: getColor('SeaBlue'),
      activeColor: getColor('SeaBlue'),
      activeHoverColor: getColor('SeaBlue'),
      hoverColor: getColor('SeaBlue'),
    },
  },
  content: {
    padding: getRem(16),
    color: getColor('UiBlack'),
  },
};
